<div class="row no-gutters px-3 py-3 my-3  mb-checkout-new-address-tile"
     data-cy="mb-checkout-new-address-tile"
     (click)="clickHandler(true)">
  <div class="col-12">
    <div class="mb-checkout-add-new-address-circular-button">
      +
    </div>
    <div>
      {{ 'address.addNewAddress' | cxTranslate }}
    </div>
  </div>
</div>
